import { render, staticRenderFns } from "./SubCompanyRoles.vue?vue&type=template&id=8e189d06&scoped=true"
import script from "./SubCompanyRoles.vue?vue&type=script&lang=js"
export * from "./SubCompanyRoles.vue?vue&type=script&lang=js"
import style0 from "./SubCompanyRoles.vue?vue&type=style&index=0&id=8e189d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e189d06",
  null
  
)

export default component.exports